module.exports = __webpack_public_path__ + "static/media/evolution_88.1ab0e5bb.svg";